import { Box, Tooltip, Typography } from '@mui/material';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { COLORS } from 'services/constants/colors';
import { getAllCountriesOptions } from 'redux/reducers/settings/selectors';
import { CountryFlag } from 'ui/CountryFlag';

export type TCountryWithFlagProps = {
	countryCode: string;
	size?: 'small' | 'medium' | 'large' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
	sx?: {
		[key: string]: string | number;
	};
	bold?: boolean;
	color?: string;
	showLabel?: boolean;
	tooltip?: boolean;
};

export const CountryWithFlag: FC<TCountryWithFlagProps> = ({
	countryCode,
	size = 'm',
	sx = {},
	bold = false,
	color,
	showLabel = true,
	tooltip = true,
}) => {
	const countries = useSelector(getAllCountriesOptions);
	const country = countries?.find?.((cntr) => cntr?.code === countryCode);
	// if (!country) return null;
	const fontSize = useMemo(() => {
		return size === 'xs'
			? '0.6rem'
			: size === 's' || size === 'small'
				? '0.7rem'
				: size === 'm' || size === 'medium'
					? '0.8rem'
					: size === 'l' || size === 'large'
						? '0.9rem'
						: size === 'xl'
							? '1.0rem'
							: size === 'xxl'
								? '1.4rem'
								: '0.7rem';
	}, [size]);
	return (
		<Tooltip
			title={tooltip ? (country?.label ?? countryCode) : ''}
			disableFocusListener={!tooltip}
			disableHoverListener={!tooltip}
			disableTouchListener={!tooltip}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 0.5,
				}}
			>
				<CountryFlag
					countryCode={countryCode}
					height={
						size === 'xs'
							? 9
							: size === 's'
								? 10
								: size === 'm'
									? 12
									: size === 'l'
										? 14
										: size === 'xl'
											? 16
											: size === 'xxl'
												? 18
												: 10
					}
				/>
				<Typography
					// variant="body1"
					sx={{
						...sx,
						fontSize,
						fontWeight: bold ? 'bold' : 'normal',
						color: COLORS.font_main,
					}}
					color={color}
				>
					{showLabel ? (country?.label ?? countryCode) : countryCode}
				</Typography>
			</Box>
		</Tooltip>
	);
};
